module.exports = __webpack_public_path__ + "img/issue.f4272e77.svg";